import { useEffect, useState } from 'react'
import { useRemoteClientGet } from '../../../../../configs/http-client'
import { CatchMessageError } from '../../../../../remote/catch-message-error'
import { useLocalStorage } from '../../../../../remote/local-storage'

export const LoadEmployees = () => {
  const [data, setData] = useState<any[]>([])

  const { remoteClientGet } = useRemoteClientGet()
  const { getUnitId } = useLocalStorage()
  useEffect(() => {
    remoteClientGet('/funcionarios', { page: 0, size: 1000, idUnidade: getUnitId() })
      .then((response: any) => {
        setData(response.data.data.content)
      })
      .catch(CatchMessageError)
  }, [])

  return {
    data
  }
}
